import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forgetPassword } from './cognitoUtils';

const Forgetpassword = () => {
  const navigate = useNavigate(); 
  const [username, setUsername] = useState('');
  const [message, setMessage] = useState('');

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const exit = await forgetPassword(username);
      // console.log(exit)

      if (exit) {
        setMessage('Reset password successful!');
        navigate(`/resetpassword?username=${username}`); 
      }
      else{
        setMessage(`${err.message || 'An unknown error occurred.'}`);
      }

    } catch (err) {
      console.error('Error in handleSignup:', err);
      setMessage(`${err.message || 'An unknown error occurred.'}`);
    }
  };
  
  return (
    <div className="wrapper">
      <div className="title-text">
        <div className={'title'}>
          Forget Password
        </div>
      </div>
      <div className="form-container">
        <div className="form-inner">
          <form onSubmit={handleSignup} className="login">
            <div className="field">
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              required
            />
            </div>
            <div className="error-message">
              <p>{message}</p>
            </div>
            <div className="field btn">
              <div className="btn-layer"></div>
              <input type="submit" value="Confirm" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Forgetpassword;
